var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDereRreshqitese(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 179,
    viewBox: "0 0 183 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2952 13.4358H13.7048V165.564H77.2952V13.4358ZM0 0V179H91V0H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.295 13.4358H105.705V165.564H169.295V13.4358ZM92 0V179H183V0H92Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 62,
    height: 151,
    fill: "url(#paint0_linear_841_1760)",
    stroke: "#DEDEDE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106.5,
    y: 14.5,
    width: 62,
    height: 151,
    fill: "url(#paint1_linear_841_1760)",
    stroke: "#DEDEDE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 79.5,
    width: 4,
    height: 19,
    rx: 2,
    stroke: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9966 145.804C30.7204 145.804 30.4966 146.027 30.4966 146.304C30.4966 146.58 30.7204 146.804 30.9966 146.804L30.9966 145.804ZM61.4076 146.657C61.6029 146.462 61.6029 146.145 61.4076 145.95L58.2257 142.768C58.0304 142.573 57.7138 142.573 57.5186 142.768C57.3233 142.963 57.3233 143.28 57.5186 143.475L60.347 146.304L57.5186 149.132C57.3233 149.327 57.3233 149.644 57.5186 149.839C57.7138 150.034 58.0304 150.034 58.2257 149.839L61.4076 146.657ZM30.9966 146.804L61.0541 146.804L61.0541 145.804L30.9966 145.804L30.9966 146.804Z",
    fill: "#C6C6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4966 127.518C31.4966 127.241 31.2727 127.018 30.9966 127.018C30.7204 127.018 30.4966 127.241 30.4966 127.518L31.4966 127.518ZM30.4966 127.518L30.4966 146.304L31.4966 146.304L31.4966 127.518L30.4966 127.518Z",
    fill: "#C6C6C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.577 79.6133C138.577 79.3371 138.353 79.1133 138.077 79.1133C137.801 79.1133 137.577 79.3371 137.577 79.6133L138.577 79.6133ZM137.577 79.6133L137.577 98.3992L138.577 98.3992L138.577 79.6133L137.577 79.6133Z",
    fill: "#C6C6C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.47 89.5063C147.746 89.5063 147.97 89.2824 147.97 89.0063C147.97 88.7301 147.746 88.5063 147.47 88.5063V89.5063ZM147.47 88.5063L128.684 88.5063V89.5063L147.47 89.5063V88.5063Z",
    fill: "#C6C6C6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_841_1760",
    x1: 85.4627,
    y1: -151.892,
    x2: -12.7197,
    y2: 145.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_841_1760",
    x1: 177.463,
    y1: -151.892,
    x2: 79.2803,
    y2: 145.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDereRreshqitese);
export default __webpack_public_path__ + "static/media/dere-rreshqitese.0f7753acc8b0a172b68ab965dfa57f1c.svg";
export { ForwardRef as ReactComponent };